export default {
  label: {
    "CDU/CSU": "#373737",
    "SPD": "#DB4240",
    "AfD": "#34A3D2",
    "FDP": "#D59300",
    "LINKE": "#96276E",
    "GRÜNE": "#1F8F17",
    "fraktionslos": "#AAAAAA",
    "Sonstige": "#888888"
  },
  bar: {
    "CDU/CSU": "#373737",
    "SPD": "#DB4240",
    "AfD": "#34A3D2",
    "FDP": "#F6BB00",
    "LINKE": "#96276E",
    "GRÜNE": "#4BA345",
    "fraktionslos": "#AAAAAA",
    "Sonstige": "#888888"
  }
};
